import Vue from 'vue'
import Router from 'vue-router'
import i18n from './plugins/languages/i18n'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    {
      path: '/',
      name: 'home',

      components: {
        view: () => import('./views/FeedSection')
      },

      meta: {
        isEdition: 'assets',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.account')}/:subject`,
      name: 'account',

      // Children routes
      children: [
        {
          path: ':subedition',
          name: 'accountChild1',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'account',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        }
      ],

      components: {
        view: () => import('./views/EditionSection')
      },

      meta: {
        isEdition: 'account',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.asset')}/:id/:subject`,
      name: 'asset',

      // Children routes
      children: [
        {
          path: ':subedition',
          name: 'assetChild1',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'asset',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        },

        {
          path: ':subid/:subedition',
          name: 'assetChild2',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'asset',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        }
      ],

      components: {
        view: () => import('./views/EditionSection')
      },

      meta: {
        isEdition: 'asset',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.assets')}`,
      name: 'assets',

      components: {
        view: () => import('./views/FeedSection')
      },

      meta: {
        isEdition: 'assets',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.map')}/:id/:subject`,
      name: 'map',

      // Children routes
      children: [
        {
          path: ':subedition',
          name: 'mapChild1',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'map',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        },

        {
          path: ':subid/:subedition',
          name: 'mapChild2',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'map',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        }
      ],

      components: {
        view: () => import('./views/EditionSection')
      },

      meta: {
        isEdition: 'map',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.maps')}`,
      name: 'maps',

      components: {
        view: () => import('./views/FeedSection')
      },

      meta: {
        isEdition: 'maps',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.billing')}/:subject`,
      name: 'billing',

      // Children routes
      children: [
        {
          path: ':subedition',
          name: 'billingChild1',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'billing',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        },

        {
          path: ':subid/:subedition',
          name: 'billingChild2',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'billing',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        },

        {
          path: ':subid/:subedition/:thirdid',
          name: 'billingChild3',
          components: {
            view: () => import('./views/EditionSection')
          },

          meta: {
            isEdition: 'billing',
            requiresUserAuth: true,
            requiresAcademyAuth: true
          }
        }
      ],

      components: {
        view: () => import('./views/EditionSection')
      },

      meta: {
        isEdition: 'billing',
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.resetPassword')}`,
      name: 'resetPassword',

      components: {
        view: () => import('./views/ResetPassword')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: `/${i18n.t('rPaths.notFound')}`,
      name: 'notFound',

      components: {
        view: () => import('./views/NotFound')
      },

      meta: {
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: `/${i18n.t('rPaths.initialSetup')}`,
      name: 'initialSetup',

      components: {
        view: () => import('./views/InitialSetup')
      },

      meta: {
        requiresUserAuth: true,
        requiresAcademyAuth: false
      }
    },

  {
      path: `/${i18n.t('rPaths.confirmForgotPassword')}`,
      name: 'confirmForgotPassword',

      components: {
        view: () => import('./views/ConfirmForgotPassword')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: encodeURI(`/${i18n.t('rPaths.confirmForgotPassword')}`),
      name: 'confirmForgotPassword',

      components: {
        view: () => import('./views/ConfirmForgotPassword')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: `/${i18n.t('rPaths.forgetPassword')}`,
      name: 'forgetPassword',

      components: {
        view: () => import('./views/ForgetPassword')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: encodeURI(`/${i18n.t('rPaths.forgetPassword')}`),
      name: 'forgetPassword',

      components: {
        view: () => import('./views/ForgetPassword')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: `/${i18n.t('rPaths.login')}/:id`,
      name: 'login',

      components: {
        view: () => import('./views/Login')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: `/${i18n.t('rPaths.clearCache')}`,
      name: 'clearCache',

      components: {
        view: () => import('./views/ClearCache')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: '/logout',
      name: 'logout',

      components: {
        view: () => import('./views/Logout')
      },

      meta: {
        requiresUserAuth: true,
        requiresAcademyAuth: true
      }
    },

    {
      path: '/return-to',
      name: 'returnTo',

      components: {
        view: () => import('./views/ReturnTo')
      },

      meta: {
        requiresUserAuth: false,
        requiresAcademyAuth: false
      }
    },

    {
      path: '*',
      redirect: { name: 'notFound' }
    }
  ],

  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (!to.meta.requiresUserAuth) {
    next()
  } else if (!to.meta.requiresAcademyAuth && router.app.$auth.isUserAuthenticated()) {
    next()
  } else if (router.app.$auth.isUserAuthenticated() && router.app.$auth.isAcademyAuthenticated()) {
    next()
  } else {
    localStorage.setItem('current_url', window.location.pathname)
    router.app.$auth.login()
  }
})

export default router
